import styled from 'styled-components';

import { TrelloView } from 'components/TrelloView/TrelloView';

import { SupplyOrderTrelloItem } from './components/SupplyOrderTrelloItem';
import { groupSupplyOrdersIntoColumns } from './constants/supplyOrderColumns';
import type { SupplyOrderRow } from './constants/supplyOrderViews';

type SupplyOrdersTrelloViewProps = {
    supplyOrders: SupplyOrderRow[];
    selectedSupplyOrderIds: string[];
    setSelectedSupplyOrderIds: React.Dispatch<React.SetStateAction<string[]>>;
    toggleSupplyOrderSelection: (supplyOrderId: string) => void;
};

export const SupplyOrdersTrelloView = ({
    supplyOrders,
    selectedSupplyOrderIds,
    setSelectedSupplyOrderIds,
    toggleSupplyOrderSelection,
}: SupplyOrdersTrelloViewProps) => {
    const initialData = {
        columns: groupSupplyOrdersIntoColumns(supplyOrders).map(({ title, supplyOrders: columnSupplyOrders }) => ({
            title,
            items: columnSupplyOrders.map((supplyOrder) => ({
                _id: supplyOrder._id,
                content: (
                    <SupplyOrderTrelloItem
                        supplyOrder={supplyOrder}
                        isSelected={selectedSupplyOrderIds.includes(supplyOrder._id)}
                        toggleSelection={() => toggleSupplyOrderSelection(supplyOrder._id)}
                    />
                ),
            })),
        })),
    };

    return (
        <Content>
            <TrelloViewContainer>
                <TrelloView
                    initialData={initialData}
                    selectedItemIds={selectedSupplyOrderIds}
                    setSelectedItemIds={setSelectedSupplyOrderIds}
                    padding="0"
                />
            </TrelloViewContainer>
        </Content>
    );
};

const TrelloViewContainer = styled.div`
    overflow-x: scroll;
`;

const Content = styled.div`
    position: relative;
    display: flex;
    flex: 1;
    overflow: hidden;
`;
